// ---------------------------------------------------------------------------
// News
// ---------------------------------------------------------------------------
// Chronologically ordered (newest first). Cards on the /news page.
// Set featured: true for the big hero card on the main page.

import bestThesisImg from '../assets/profile/BestThesis.png';
import workshopGroupImg from '../assets/tinytapeout/workshop_group.jpg';

const news = [
  {
    date: '2026-04-10',
    title: 'TinyTapeout Workshop',
    description: 'Teaching students to design and fabricate custom silicon chips with open-source tools.',
    link: '/tinytapeout',
    badge: 'Featured Event',
    featured: true,
    image: workshopGroupImg,
  },
  {
    date: '2025-06-06',
    title: 'Best Thesis Award',
    description: 'Awarded Best Thesis at the 2025 ECE Annual Awards, Northwestern University.',
    link: 'https://www.mccormick.northwestern.edu/electrical-computer/news-events/news/articles/2025/2025-ece-annual-award-winners.html',
    badge: 'Award',
    image: bestThesisImg,
  },
];

export default news;
